import { Navigate, Route, Routes } from "react-router-dom"
import Auth from "~/modules/auth/Auth"
import Login from "~/modules/auth/login/Login"
import { BlockContentRouter } from "~/modules/block-content"
import { CategoryRouter } from "~/modules/category"
import { ContactRouter } from "~/modules/contact-form"
import Dashboard from "~/modules/dashboard/Dashboard"
import { ParentQuestionRouter } from "~/modules/parent-question"
import { MediaRouter } from "~/modules/media"
import { MenuRouter } from "~/modules/menu/Router"
import { SeoSettingRouter } from "~/modules/seoSetting"
import { SettingRouter } from "~/modules/settings/Router"
import { PuckRouter } from "~/modules/ui-builder"
import { UserRouter } from "~/modules/users/Router"
import ProtectedRoute from "~/utils/ProtectedRoutes"
import RequireAuth from "~/utils/RejectedRoutes"
import history from "."
import { MainLayout } from "../components/layout"
import { Paths } from "../constants"
import { BaseSystemRouter } from "../modules/base-system"
import { GeneralSettingRouter } from "../modules/general-setting"
import { JobDetailRouter } from "../modules/job-detail/Router"
import { PageRouter } from "../modules/page/index"
import { PostRouter } from "../modules/post"
import { RecruitmentRouter } from "../modules/recruitment/Router"
import { Preview } from "../modules/ui-builder/pages/preview"
import { UIBuilder } from "../modules/ui-builder/pages/ui-builder"
import { HistoryRouter } from "./HistoryRouter"

export const Navigator = () => {
  return (
    <HistoryRouter history={history}>
      <Routes>
        <Route
          element={
            <RequireAuth>
              <Auth />
            </RequireAuth>
          }
        >
          <Route path={Paths.PUBLIC.LOGIN.PATH} element={<Login />} />
        </Route>
        <Route path="/ui-builder/:id/preview" element={<Preview />} />
        <Route
          path="/ui-builder/:id"
          element={
            <ProtectedRoute>
              <UIBuilder />
            </ProtectedRoute>
          }
        />
        <Route
          element={
            <ProtectedRoute>
              <MainLayout />
            </ProtectedRoute>
          }
        >
          <Route path="/" element={<Navigate to={Paths.DASHBOARD.DETAIL.PATH} replace />} />
          <Route path={Paths.DASHBOARD.DETAIL.PATH} element={<Dashboard />} />
          <Route path={`${Paths.SETTINGS.LIST.PATH}/*`} element={<SettingRouter />} />
          <Route path={`${Paths.POSTS.LIST.PATH}/*`} element={<PostRouter />} />
          <Route path={`${Paths.MEDIA.LIST.PATH}/*`} element={<MediaRouter />} />
          <Route path={`${Paths.SEOSETTING.LIST.PATH}/*`} element={<SeoSettingRouter />} />
          <Route path={`${Paths.CONTACTFORM.LIST.PATH}/*`} element={<ContactRouter />} />
          <Route path={`${Paths.CATEGORIES.LIST.PATH}/*`} element={<CategoryRouter />} />
          <Route path={`${Paths.USERS.LIST.PATH}/*`} element={<UserRouter />} />
          <Route path={`${Paths.MENUS.DETAIL.PATH}/*`} element={<MenuRouter />} />
          <Route path={`${Paths.PAGES.LIST.PATH}/*`} element={<PageRouter />} />
          <Route path={`${Paths.PUCK.LIST.PATH}/*`} element={<PuckRouter />} />
          <Route path={`${Paths.BLOCK_CONTENT.LIST.PATH}/*`} element={<BlockContentRouter />} />
          <Route path={`${Paths.GENERAL_SETTING.LIST.PATH}/*`} element={<GeneralSettingRouter />} />
          <Route path={`${Paths.BASESYSTEM.LIST.PATH}/*`} element={<BaseSystemRouter />} />
          <Route path={`${Paths.RECRUITMENT.LIST.PATH}/*`} element={<RecruitmentRouter />} />
          <Route path={`${Paths.JOB_DETAIL.LIST.PATH}/*`} element={<JobDetailRouter />} />
          <Route path={`${Paths.PARENT_QUESTIONS.LIST.PATH}/*`} element={<ParentQuestionRouter />} />
        </Route>
      </Routes>
    </HistoryRouter>
  )
}
